import { useState } from "react";
import classes from "./AuthenticationModal.module.css";
import Modal from "../Modal/Modal";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import { Text } from "..";

const AuthenticationModal = ({
  heading,
  children,
  info,
  onClose,
  className,
}) => {
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();
  const handleClose = () => {
    setIsActive(false);
    onClose && onClose();
    !onClose && navigate("/login");
  };
  return (
    <div className={classes.wrapper}>
      <Modal
        className={clsx(classes.modal, classes.myModal, className)}
        isActive={isActive}
        heading={heading}
        onClose={handleClose}
      >
        {info && (
          <Text base primitive300 textCenter className={classes.info}>
            {info}
          </Text>
        )}
        {children}
      </Modal>
    </div>
  );
};
export default AuthenticationModal;
